import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=820fedd8&scoped=true"
import script from "./order_detail.vue?vue&type=script&lang=js"
export * from "./order_detail.vue?vue&type=script&lang=js"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=820fedd8&prod&lang=css"
import style1 from "./order_detail.vue?vue&type=style&index=1&id=820fedd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820fedd8",
  null
  
)

export default component.exports